<template>
   <div  class="step4">
   		<div class="" style="width: 80px;height: 80px;margin: 45px auto 35px">
   				<img src="@/assets/img/dataImport/dui.png" style="width:100%" alt="" srcset="">
   		</div>
   	<div>
   		<p class="p1">导入成功</p>
   		<p class="p2">导入成功人数共计100人</p>
   		<p style="margin-bottom: 6px">如需查看数据详情或对导入数据进行调整，可点击<font>查看详情</font></p>
   		<p>如需直接提交数据，请点击下方确认提交按钮</p>
   	</div>
   	<div style="margin-top: 90px;padding-bottom: 24px">
   		<el-button type="primary">确认提交</el-button>
   	</div>
   </div>
      
</template>

<script>
  export default {
    name: "step4",
    props: {
        step: {
        	type: String,
        	default: '',
        }
    },
    data() {
      return {
         
      };
    },
    methods: {
  
    }
  };
</script>

<style scoped >
   .step4>div{
   	text-align: center;
   }
   .step4>div p{
   	font-size:13px;
   	font-family:PingFangSC-Regular,PingFang SC;
   	font-weight:400;
   	color:rgba(51,51,51,1);
   	line-height:18px;
   }
   .step4>div .p1{
   	font-size:15px;
   	font-family:PingFangSC-Regular,PingFang SC;
   	font-weight:400;
   	color:rgba(51,51,51,1);
   	line-height:21px;
   }
   .step4>div .p2{
   	font-size:12px;
   	font-family:PingFangSC-Regular,PingFang SC;
   	font-weight:400;
   	color:rgba(102,102,102,1);
   	line-height:17px;
   	margin: 5px 0 80px;
   }
	 .step4>div p font{
	 color: #0EA5E5;
	 padding: 0 4px;
	 cursor: pointer;
	 }
</style>
